"use client";

/**
 * ThemeToggle — alterna dark/light mode sem depender do next-themes.
 * Persiste preferência em localStorage; script inline no layout.tsx
 * garante que o tema certo carrega antes do React hidratar (sem FOUC).
 */

import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

export function ThemeToggle({ className = "" }: { className?: string }) {
  const [isDark, setIsDark] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    // Lê a classe atual do <html> (já foi definida pelo script inline)
    setIsDark(document.documentElement.classList.contains("dark"));
  }, []);

  const toggle = () => {
    const next = !isDark;
    setIsDark(next);
    try {
      localStorage.setItem("insightchat-theme", next ? "dark" : "light");
    } catch {}
    if (next) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  };

  // Renderiza placeholder antes de montar para evitar mismatch de hydration
  if (!mounted) {
    return (
      <button
        aria-label="Alternar tema"
        className={`p-1.5 rounded hover:bg-muted transition-colors text-muted-foreground ${className}`}
        disabled
      >
        <Moon className="h-4 w-4" />
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      aria-label={isDark ? "Mudar para modo claro" : "Mudar para modo escuro"}
      title={isDark ? "Modo claro" : "Modo escuro"}
      className={`p-1.5 rounded hover:bg-muted transition-colors text-muted-foreground hover:text-foreground ${className}`}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
